import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(`Missing Supabase environment variables:
    URL: ${supabaseUrl ? '✓' : '✗'}
    Key: ${supabaseAnonKey ? '✓' : '✗'}
  Please check your .env.local file.`);
}

console.log('Initializing Supabase client with URL:', supabaseUrl);

export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
    global: {
      headers: {
        'x-client-info': 'turingtalks-frontend',
      },
    },
  }
);

// Test the connection
const testConnection = async () => {
  try {
    console.log('Testing Supabase connection...');
    
    // First, test a simple query
    const { error: countError } = await supabase
      .from('tools')
      .select('count');

    if (countError) {
      console.error('Failed to count tools:', countError);
      if (countError.message.includes('relation "public.tools" does not exist')) {
        console.error('The tools table does not exist. Please run the database setup SQL.');
      }
      return;
    }

    console.log('Successfully connected to Supabase!');
    
  } catch (err) {
    console.error('Failed to connect to Supabase:', err);
  }
};

// Run the test
console.log('Environment check:');
console.log('- URL:', supabaseUrl ? '✓ Present' : '✗ Missing');
console.log('- Key:', supabaseAnonKey ? '✓ Present' : '✗ Missing');
testConnection(); 